
$(document).ready(function(e){
	if ($(document).find('#ClientReviewForm').length > 0){

		var dom = $(document).find('#ClientReviewForm');
		
		// when we select the portfolio mandated strategy (ie "Balanced","Conservative")
		dom.on('change', '.field input[name="PortfolioMandatedStrategy"]', function(event){
			
			var dateField = $(document).find('.field input[name="PortfolioMandatedStrategyDate"]');
			
			if(
				$(this).val() == 'DIMS Income' ||
				$(this).val() == 'DIMS Conservative' ||
				$(this).val() == 'DIMS Balanced' ||
				$(this).val() == 'DIMS Growth' ||
				$(this).val() == 'DIMS High Growth' ){
					dateField.val( '01/06/2015' );
				}else{
					dateField.val( '' );
				}
		});
	}
});


